import { Excavator, WorkOrderStatuses } from "~/workorder/types";

export const isOperatingTimeRequired = (excavator?: Excavator | null): boolean => (
    !!excavator?.operatingTimeAllowed
);

export const isOperatingCountRequired = (excavator?: Excavator | null): boolean => (
    !!excavator?.operatingCountAllowed
);

export const excavatorHasNoTracker = (tracker?: number | null): boolean => (
    tracker == null || tracker === 0
);

export interface CanEditWorkOrderOperatingTimeParams {
    status: number;
    setLiveOperatingHours: boolean;
    allowManualOperatingTimeUpdate: boolean;
    tracker?: number | null;
}

export const canEditWorkOrderOperatingTime = ({
    status,
    setLiveOperatingHours,
    allowManualOperatingTimeUpdate,
    tracker,
}: CanEditWorkOrderOperatingTimeParams): boolean => (
    status !== WorkOrderStatuses.APPROVED
    && !setLiveOperatingHours
    && allowManualOperatingTimeUpdate
    && excavatorHasNoTracker(tracker)
);

export const canEditWorkOrderOperatingCount = (status: number): boolean => (
    status !== WorkOrderStatuses.APPROVED
);

export const OPERATING_METRIC_MIN = 0;
export const OPERATING_METRIC_MAX = 999999999;

export const isOperatingMetricInRange = (value: number | null): boolean => (
    value === null || (value >= OPERATING_METRIC_MIN && value <= OPERATING_METRIC_MAX)
);

export const formatOperatingMetricInputValue = (value: number | null): string => {
    if (value === null || value === undefined) {
        return '';
    }
    return String(value);
};

export const parseOperatingMetricInputValue = (raw: string): number | null => {
    const trimmed = raw.trim();
    if (trimmed === '') {
        return null;
    }
    const parsed = Number(trimmed);
    if (Number.isNaN(parsed) || parsed < 0) {
        return null;
    }
    return parsed;
};

export const operatingMetricsEqual = (
    a: number | null,
    b: number | null,
): boolean => {
    if (a === null && b === null) {
        return true;
    }
    if (a === null || b === null) {
        return false;
    }
    return a === b;
};